import { render, staticRenderFns } from "./otherArt.vue?vue&type=template&id=4249a8dc&scoped=true&"
import script from "./otherArt.vue?vue&type=script&lang=js&"
export * from "./otherArt.vue?vue&type=script&lang=js&"
import style0 from "./otherArt.vue?vue&type=style&index=0&id=4249a8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249a8dc",
  null
  
)

export default component.exports